import { Injectable } from "@angular/core";
import { BaseDataService, HttpService } from "./base.service";
import { ManagementCode } from "../..";

@Injectable()
export class ManagementCodeService extends BaseDataService<ManagementCode> {
  constructor(http: HttpService) {
    super(http, "managementcode");
  }

  createInstance(options: any): ManagementCode {
    return new ManagementCode(options);
  }

  getActive() {
    return this.http.request(`${this.resourceUrl}/active`);
  }
}
